import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Insurance = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Insurance</h6>
          <hr />
          <h1 className="banner-title">
            Transform the Insurance Sector with <br /> Advanced Analytics and
            Solutions
          </h1>

          <p>
            Enhance underwriting, claims management, and customer experiences
            with data-driven insights.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/young-happy-woman-shaking-hands-with-real-estate-agent-while-her-husband-is-using-touchpad-office_637285-2822.jpg"
          alt="Insurance Analytics Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="col_yell text-center">Insurance</h6>
              <h2 className="text-center">
                Advanced Analytics for the Insurance Industry
              </h2>
              <p className="text-center">
                In the rapidly changing insurance industry, our data-driven
                solutions help optimize underwriting, improve claims management,
                and create personalized customer experiences. We empower
                insurers to predict risks, enhance operational efficiency, and
                stay competitive by using the latest analytics techniques.
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Insurance Solutions</h2>
              <p className="text-center mb-0">
                Unlock the potential of predictive analytics, risk assessment,
                and customer insights to transform your insurance business.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Risk Assessment</a>
              </h3>
              <p className="mb-4">
                Leverage predictive models to assess risk more accurately,
                optimize underwriting processes, and enhance decision-making.
              </p>
            </div>
          </div>

          {/* <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Claims Management</a>
              </h3>
              <p className="mb-4">
                Improve claims management efficiency by analyzing data in real-time and optimizing the claims process for faster resolution.
              </p>
            </div>
          </div> */}

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Fraud Detection</a>
              </h3>
              <p className="mb-4">
                Detect fraudulent claims by analyzing historical data patterns
                and using machine learning models to predict and prevent fraud.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Customer Personalization</a>
              </h3>
              <p className="mb-4">
                Enhance customer experience with personalized insurance
                policies, tailored recommendations, and targeted promotions.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Predictive Analytics</a>
              </h3>
              <p className="mb-4">
                Use predictive analytics to forecast claims trends, optimize
                pricing strategies, and improve policyholder retention.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="">
                  Ready to Transform Your Insurance Business?
                </h2>
                <p className="mt-3">
                  Unlock the power of advanced analytics to optimize
                  underwriting, improve claims management, and provide
                  personalized services to your policyholders.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Insurance Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Insurance;
